
import { useEffect, useRef, useCallback, useState } from "react";

export interface ToastProps {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
}

export function useToast() {
  const [toasts, setToasts] = useState<any[]>([]);
  const cleanupRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    const unsubscribe = () => {
      // Cleanup function - no-op for now but must be a function
    };

    cleanupRef.current = unsubscribe;

    return () => {
      if (typeof cleanupRef.current === "function") {
        cleanupRef.current();
      }
    };
  }, []);

  const addToast = useCallback((props: ToastProps) => {
    const id = Date.now().toString();
    const newToast = { id, ...props };
    setToasts(prev => [...prev, newToast]);
    
    // Auto-remove toast after 5 seconds
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 5000);
  }, []);

  return { toasts, toast: addToast };
}

// Export toast as a callable function
export const toast = (props: ToastProps) => {
  // This is a temporary implementation for SSR compatibility
  // In a real app, you'd use a toast context or state management
  console.log('Toast:', props);
};
